import React, { useEffect } from 'react';
import { Row, Col } from 'antd';

import { Footer } from './Footer';
import { TextInput } from './TextInput';
import { TextArea } from '../../components/TextArea';
import { Paragraph, Title } from '@/components/Typography';
import { useCalculateAngles, useCreateReba } from '@/hooks/useReba';
import { usePersonalisedReportContext } from '../../../context';

interface WorkConditionsProps {
	personalisedReport: any;
}

export function WorkConditions({ personalisedReport: report }: Readonly<WorkConditionsProps>) {
	const { mutateAsync: createReba } = useCreateReba();
	const { mutateAsync: calculateAngles } = useCalculateAngles();
	const { personalisedReport, file_id } = usePersonalisedReportContext();

	useEffect(() => {
		if (!file_id || !personalisedReport?.id || report?.reba?.id) {
			return;
		}

		const createRebaReport = async () => {
			const payload = {
				file_id,
				force: 1,
				comment: '',
				coupling: 1,
				repetition: 1,
				collection_date: new Date(),
				sector_id: report.basic_information.sector_id,
				company_id: report.basic_information.company_id,
				workstation: report.basic_information.workstation_id,
				workstation_id: report.basic_information.workstation_id,
				organization_id: report.basic_information.organization_id
			};

			try {
				await calculateAngles({
					organization_id: report.basic_information.organization_id,
					company_id: report.basic_information.company_id,
					file_id: file_id
				});
				await createReba(payload);
			} catch (error) {
				console.error('Failed to create REBA report:', error);
			}
		};

		createRebaReport();
	}, [file_id, report, createReba]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Row justify="center" gutter={[5, 20]}>
			<Col xs={21}>
				<Row align="middle">
					<Col xs={24}>
						<Title level={4}>Work Conditions</Title>
					</Col>
					<Col xs={24} style={{ marginBottom: '20px' }}>
						<Paragraph>Select the restrictions perceived in the evaluated working condition</Paragraph>
					</Col>
				</Row>
				<Row justify="center">
					<Col span={23}>
						<Row justify="start">
							<Col span={24}>
								<Title level={5}>Work schedule</Title>
							</Col>
							<TextInput
								type="hours"
								message="Insert work schedule"
								namePath={['work_conditions', 'work_hours']}
							/>
							<TextInput namePath={['work_conditions', 'work_minutes']} type="minutes" />
						</Row>
						<Row justify="center" gutter={[0, 10]}>
							<TextArea
								namePath={['work_conditions', 'place_description']}
								title="Summary description of the place"
							/>
							<TextArea
								namePath={['work_conditions', 'expected_task_description']}
								title="Simplified description of the expected task"
							/>
							<TextArea
								namePath={['work_conditions', 'performed_task_description']}
								title="Simplified description of the task performed"
							/>
						</Row>
					</Col>
				</Row>
				<Footer />
			</Col>
		</Row>
	);
}
